import { Component, OnDestroy, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoadingOverlayComponent } from './layout/loading-overlay/loading-overlay.component';
import { OverlayService } from './services/overlay.service';
import { TAB_TITLE_PREFIX } from './shared/constants';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterModule, LoadingOverlayComponent],
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'Starte...';
    showGlobalOverlay = false;

    readonly #ngUnsubscribe = new Subject<void>();

    constructor(
        private readonly _overlayService: OverlayService,
        private readonly _title: Title,
        private readonly _meta: Meta,
        private readonly _router: Router,
    ) {}

    ngOnInit() {
        this._overlayService.globalOverlayObs.pipe(takeUntil(this.#ngUnsubscribe)).subscribe((show) => {
            this.showGlobalOverlay = show;
        });

        this._router.events.pipe(takeUntil(this.#ngUnsubscribe)).subscribe((event: Event) => {
            this.#navigationInterceptor(event);
        });

        this._title.setTitle(TAB_TITLE_PREFIX + this.title);

        this._meta.addTag({ name: 'version', content: environment.version });
    }

    ngOnDestroy() {
        this.#ngUnsubscribe.next();
        this.#ngUnsubscribe.complete();
    }

    #navigationInterceptor(event: Event): void {
        const LOG_NAVIGATION_EVENTS = false;

        if (event instanceof NavigationStart) {
            LOG_NAVIGATION_EVENTS && console.log(`[AppComponent] NavigationStart ${event.id}`);
            this._overlayService.setGlobalOverlay(true);
        } else if (event instanceof NavigationEnd) {
            LOG_NAVIGATION_EVENTS && console.log(`[AppComponent] NavigationEnd ${event.id}`);
            this._overlayService.setGlobalOverlay(false);
        } else if (event instanceof NavigationCancel) {
            LOG_NAVIGATION_EVENTS && console.log(`[AppComponent] NavigationCancel ${event.id}`);
            this._overlayService.setGlobalOverlay(false);
        } else if (event instanceof NavigationError) {
            LOG_NAVIGATION_EVENTS && console.log(`[AppComponent] NavigationError ${event.id}`);
            this._overlayService.setGlobalOverlay(false);
        }
    }
}
